import { TextField } from "@mui/material";
import React, { useState } from "react";
import { breadcrumbNameMap } from "../../../utils/helperData";
import Breadcrumbs from "../../../customComponent/BreadCrumbs";
import { Formik } from "formik";
import * as Yup from "yup";
import { addSurfaceMaster } from "../../../../redux/action/Master/MasterAction";
import { SURFACE_MASTER } from "../../../utils/RouteConstant";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import SuccessMasterModal from "../MasterTable/SuccessMasterModal";
import { toast } from "react-toastify";

const AddSurfaceMaster = () => {
  const [openSaveModal, setOpenSaveModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleOpenSaveModal = () => setOpenSaveModal(true);
  const handleCloseSaveModal = () => {
    setOpenSaveModal(false);
    navigate(SURFACE_MASTER);
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
  });

  const handleSave = async (values) => {
    try {
      await dispatch(addSurfaceMaster(values));
      handleOpenSaveModal();
    } catch (err) {
      const errorMessage = err?.response?.data?.message || err.message || "An error occurred";
      toast.error(errorMessage);
    }
  };
  const handleCancel = () => {
    navigate(SURFACE_MASTER);
  };
  return (
    <div>
      <div className="mb-6">
        <h2 className="text-3xl font-bold mb-6">Surface Master</h2>
        <Breadcrumbs breadcrumbNameMap={breadcrumbNameMap} />
      </div>
      <div className="mx-auto bg-white shadow-lg rounded-lg p-8">
        <div>
          <h2 className="text-2xl font-base font-poppins mb-8 text-[#202224]">
            Add New Surface Master
          </h2>
        </div>
        <Formik
          initialValues={{ name: "" }}
          validationSchema={validationSchema}
          onSubmit={handleSave}
        >
          {({ handleSubmit, handleChange, values, errors, touched }) => (
            <form onSubmit={handleSubmit}>
              <div>
                <h3 className="text-base font-base text-[#1C3664] mb-2">
                  Details
                </h3>
                <div
                  style={{ borderBottom: "3px solid #1C3664", width: "5%" }}
                ></div>
                <div className="space-y-4 md:space-y-6 pt-10">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                    <TextField
                      label="Name"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      error={touched.name && Boolean(errors.name)}
                      helperText={touched.name && errors.name}
                      fullWidth
                    />
                  </div>
                </div>
              </div>

              <div className="flex justify-end space-x-4 mt-4">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-[#1C3664] text-white rounded-md"
                >
                  Save Details
                </button>
              </div>
            </form>
          )}
        </Formik>
        <br />
      </div>

      <SuccessMasterModal
        open={openSaveModal}
        title="Success"
        message="New Surface Master added successfully"
        onClose={handleCloseSaveModal}
      />
    </div>
  );
};

export default AddSurfaceMaster;
